import Vue from 'vue'
import ElementUI from 'element-ui';
import VueRouter from 'vue-router';
import App from './App.vue';
import Home from './home.vue';
import Profile from './profile.vue';

import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);
Vue.use(VueRouter);

Vue.config.productionTip = false

const routes = [
  { path: '/', name: 'home', component: Home },
  { path: '/profile', name: 'profile', component: Profile }  
]; 

const router = new VueRouter({
  routes 
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
